import { observer } from 'mobx-react-lite';
import React from 'react';
import BusinessInformation from './BusinessInformation';
import BusinessInformationPlus from './BusinessInformationPlus';
import { V2_TYPE } from './helperV2';

const BusinessInformationV2 = (props) => {
    if (Number(props?.applicationForm?.type) === V2_TYPE.PLUS) {
        return <BusinessInformationPlus {...props} />;
    }

    return <BusinessInformation {...props} />;
};

export default observer(BusinessInformationV2);
